
const MapSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white px-6">
      <div className="max-w-7xl mx-auto">
        {/* Map */}
        <div className="rounded-3xl overflow-hidden shadow-xl mb-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26234.27771!2d133.9350!3d34.6617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDM5JzQyLjEiTiAxMzPCsDU2JzA2LjAiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="おかやま整形外科の地図"
          ></iframe>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Address & Contact */}
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
              所在地・お問い合わせ
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">住所</p>
                  <p className="text-gray-700">
                    〒700-0000<br />
                    岡山市北区○○町1-2-3
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">電話番号</p>
                  <a href="tel:086-012-3456" className="text-[#007bbb] text-lg font-semibold hover:text-[#006399]">
                    086-012-3456
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-printer-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">FAX</p>
                  <p className="text-gray-700">086-012-3457</p>
                </div>
              </div>
            </div>
          </div>

          {/* Transportation */}
          <div className="bg-gray-50 rounded-3xl p-8 lg:p-10">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
              交通手段
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-train-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">電車でお越しの方</p>
                  <p className="text-gray-700 leading-relaxed">
                    JR岡山駅より徒歩15分<br />
                    岡山電気軌道「○○駅」より徒歩5分
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-bus-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">バスでお越しの方</p>
                  <p className="text-gray-700 leading-relaxed">
                    岡山駅前バスターミナルより<br />
                    「○○行き」乗車、「○○町」下車徒歩3分
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-[#007bbb] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-car-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 mb-1">お車でお越しの方</p>
                  <p className="text-gray-700 leading-relaxed">
                    山陽自動車道「岡山IC」より約20分<br />
                    駐車場完備（10台）
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
